import * as service from './compliance.service.js'

export default {
  data() {

    return {
      mahc_columns: ['TitleNumber', 'Description', 'Actions'],
      optionstable: {
        headings: {
          TitleNumber : 'Title',

          Actions: ''
        },
        labelPosition: 'top',

        /*    isediting: false,
         EditableColID: '',
         role: '',*/
        // sortIcon: {base: 'glyphicon', up: 'glyphicon-chevron-up', down: 'glyphicon-chevron-down'},
        perPage: 100,
        orderBy: { ascending:true },
        perPageValues: [5, 10, 25, 50, 100],
        /*  sortable: ["ActionDate","Description", "CommentedBy", "ActionTypeName"],*/
        sortable:[],
        texts: {
          filterPlaceholder: 'Search...',
          limit: 'rows per page:',
          noResults: 'No matching records',
        }
      },

      MahcCodes: [],
      MahcCodeTree: [],
      mahcnumber: '',
      MahcRowDetail:[]

    }
  },
  mounted() {


    this.GetAllMahc()
    this.GetAllMahcCodeAsTree()

  },

  methods: {
    applyFilter(letter) {
      this.selectedLetter = letter;
      Event.$emit('vue-tables.filter::alphabet', letter);
    },
    viewMahc1(detail)
    {
      this.MahcRowDetail = detail ? detail : []
      $('#MahcPopup').modal('show')

    },
    GetMahcId(id)
    {

this.GetAllMahc(id)

    },

    viewMahc()
    {


    },


    GetAllMahc(id) {
      let context = this
      loader.startLoader()
      service.GetAllMahc(id).then(function (response) {

        if (response && response != null) {
          response.map(function(item){

            item["TitleNumber"] = item.Number+" - "+item.Title

          });
          context.MahcCodes = response
          tooltip.startTooltip(50)

        }
        else {

          context.MahcCodes = []
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    GetAllMahcCodeAsTree() {
      let context = this
      loader.startLoader()
      service.GetAllMahcCodeAsTree().then(function (response) {

        if (response && response != null) {




          context.MahcCodeTree = response


        }
        else {

          context.MahcCodeTree = []
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },


    cancelpopup: function () {

      $('#Addkudosmodel').modal('hide')
    },


  }
}



// WEBPACK FOOTER //
// ./src/pages/Compliance/mahc.controller.js